import { useParams } from "react-router";
import { RoofServicePage } from "~/components/roofing/Site";
import { CampaignsPage, InspectionPage, OfficePage, ProjectPage } from "~/components/roofing/Flows";
import { ContactPage } from "~/components/roofing/Contact";
import type { Route } from "./+types/roofing.page";

const pages = {
  repair: () => <RoofServicePage service="repair" />,
  replacement: () => <RoofServicePage service="replacement" />,
  care: () => <RoofServicePage service="care" />,
  inspection: InspectionPage, project: ProjectPage, office: OfficePage, campaigns: CampaignsPage, contact: ContactPage,
};
const titles: Record<string, string> = { repair: "Roof repair", replacement: "Roof replacement", care: "Roof care", inspection: "Request an inspection", project: "My roof", office: "Office preview", campaigns: "Advertising & follow-up", contact: "Contact & free estimates" };
export function loader({ params }: Route.LoaderArgs) {
  if (!params.page || !Object.hasOwn(pages, params.page)) throw new Response("Not found", { status: 404 });
  return { page: params.page };
}
export const meta: Route.MetaFunction = ({ data }) => [{ title: `${titles[data?.page ?? ""] ?? "Roofing"} | Ridge & Rafter` }, { name: "description", content: "Explore the fictional Ridge & Rafter roofing concept by Goat Squad Studios. Local demo only; no real bookings or messages." }, { name: "robots", content: "noindex, follow" }];
export default function RoofingPage() { const { page } = useParams(); const Page = pages[page as keyof typeof pages]; return <Page />; }
